'use client';

import { useState } from 'react';

interface AboutValuesProps {
  eyebrow: string;
  title: string;
  description: string;
  items: Array<{
    title: string;
    description: string;
  }>;
}

export function AboutValues({
  eyebrow,
  title,
  description,
  items,
}: AboutValuesProps) {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="animate-in fade-in-0 slide-in-from-bottom-4 grid gap-8 rounded-[2rem] border border-black/5 bg-white/80 px-6 py-8 shadow-[0_20px_80px_rgba(24,26,29,0.06)] backdrop-blur-sm duration-700 dark:border-white/10 dark:bg-[#10171d]/90 dark:shadow-[0_20px_80px_rgba(0,0,0,0.35)] sm:px-8 md:grid-cols-[0.9fr_1.1fr] md:px-10 md:py-10">
      <div className="max-w-xl">
        <p className="mb-3 text-xs font-semibold uppercase tracking-[0.28em] text-[#506C83]">
          {eyebrow}
        </p>
        <h2 className="text-3xl font-semibold tracking-[-0.04em] text-[#181A1D] dark:text-white sm:text-4xl">
          {title}
        </h2>
        <p className="mt-4 text-sm leading-7 text-slate-600 dark:text-slate-300 sm:text-base">
          {description}
        </p>
      </div>

      <div className="rounded-[1.75rem] border border-black/5 bg-[#f6f7f4] p-3 dark:border-white/10 dark:bg-[#0d1419]">
        {items.map((item, index) => {
          const isOpen = openIndex === index;

          return (
            <div
              key={item.title}
              className="border-b border-black/8 px-3 py-2 transition-colors duration-300 last:border-b-0 hover:border-[#506C83]/20 dark:border-white/10"
            >
              <button
                type="button"
                onClick={() => setOpenIndex(isOpen ? -1 : index)}
                className="flex w-full items-center justify-between gap-4 py-4 text-left"
              >
                <span className="text-lg font-medium tracking-[-0.03em] text-[#181A1D] dark:text-white">
                  {item.title}
                </span>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-[#506C83] text-xl text-white">
                  {isOpen ? '-' : '+'}
                </span>
              </button>
              {isOpen ? (
                <p className="pb-5 pr-12 text-sm leading-7 text-slate-600 dark:text-slate-300 sm:text-base">
                  {item.description}
                </p>
              ) : null}
            </div>
          );
        })}
      </div>
    </section>
  );
}
